(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aquatix-media-with-text"] && !Shopify.designMode) return;
  try {
    
(function () {

  /* ---------- Carousel ---------- */
  function initCarousel(el) {
    if (el.dataset.aqxInit) return;
    el.dataset.aqxInit = '1';

    var track    = el.querySelector('[data-aqx-track]');
    var slides   = Array.prototype.slice.call(el.querySelectorAll('.aqx-carousel__slide'));
    var dots     = Array.prototype.slice.call(el.querySelectorAll('.aqx-carousel__dot'));
    var captions = Array.prototype.slice.call(el.closest('.image-with-text__media-item').querySelectorAll('.aqx-carousel__caption'));
    var btnPrev  = el.querySelector('.aqx-carousel__btn--prev');
    var btnNext  = el.querySelector('.aqx-carousel__btn--next');
    var counter  = el.querySelector('[data-aqx-current]');
    var count    = slides.length;
    var current  = 0;
    var startX   = 0;

    if (count <= 1) return;

    function goTo(index) {
      var prevVideo = slides[current] && slides[current].querySelector('video');
      if (prevVideo) prevVideo.pause();

      current = (index + count) % count;
      track.style.transform = 'translateX(-' + (current * 100) + '%)';

      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === current);
      });

      if (counter) counter.textContent = current + 1;

      captions.forEach(function (c, i) {
        c.classList.toggle('is-active', i === current);
      });

      var nextVideo = slides[current] && slides[current].querySelector('video');
      if (nextVideo) nextVideo.play().catch(function () {});
    }

    if (btnPrev) btnPrev.addEventListener('click', function () { goTo(current - 1); });
    if (btnNext) btnNext.addEventListener('click', function () { goTo(current + 1); });

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { goTo(i); });
    });

    el.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX;
    }, { passive: true });

    el.addEventListener('touchend', function (e) {
      var diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) goTo(diff > 0 ? current + 1 : current - 1);
    }, { passive: true });
  }

  function initAllCarousels(root) {
    (root || document).querySelectorAll('[data-aqx-carousel]:not([data-aqx-init])').forEach(initCarousel);
  }

  /* ---------- Discourage video downloads ---------- */
  function muteVideo(v) {
    v.muted = true;
    v.setAttribute('muted', '');
    v.addEventListener('volumechange', function () {
      if (!v.muted) v.muted = true;
    });
  }

  function guardVideos(root) {
    (root || document).querySelectorAll('.aquatix-mwt video:not([data-aqx-guarded])').forEach(function (v) {
      v.dataset.aqxGuarded = '1';
      muteVideo(v);
      v.addEventListener('contextmenu', function (e) { e.preventDefault(); });
      v.setAttribute('controlsList', 'nodownload noplaybackrate noremoteplayback');
      v.disablePictureInPicture = true;
      v.disableRemotePlayback = true;
    });
  }

  /* ---------- Click-to-play video facade ---------- */
  function initVideoFacade(el) {
    if (el.dataset.aqxInit) return;
    el.dataset.aqxInit = '1';

    var src = el.dataset.videoSrc;
    if (!src) return;

    var video = null;

    function buildVideo() {
      if (video) return video;
      video = document.createElement('video');
      video.src = src;
      video.controls = true;
      video.preload = 'auto';
      video.setAttribute('playsinline', '');
      video.setAttribute('controlsList', 'nodownload noplaybackrate noremoteplayback');
      video.disablePictureInPicture = true;
      video.disableRemotePlayback = true;
      muteVideo(video);
      video.addEventListener('contextmenu', function (e) { e.preventDefault(); });
      video.style.cssText = 'width:100%;height:100%;object-fit:cover;display:block;';
      return video;
    }

    /* Warm the buffer in the background, but only after the page has finished
       loading and gone idle, so it never competes with render or LCP. The
       detached element keeps whatever it buffers, so playback is instant on click. */
    function warm() {
      buildVideo().load();
    }
    function scheduleWarm() {
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(warm, { timeout: 4000 });
      } else {
        setTimeout(warm, 1500);
      }
    }
    if (document.readyState === 'complete') {
      scheduleWarm();
    } else {
      window.addEventListener('load', scheduleWarm, { once: true });
    }

    el.addEventListener('click', function () {
      buildVideo();
      video.autoplay = true;
      el.replaceWith(video);
      video.play().catch(function () {});
    });
  }

  /* ---------- Voice Note ---------- */
  function initVoiceNote(el) {
    if (el.dataset.init) return;
    el.dataset.init = '1';

    var audioUrl = el.dataset.audio;
    if (!audioUrl) return;

    var audio    = new Audio(audioUrl);
    var btn      = el.querySelector('.aquatix-voice-note__btn');
    var waveform = el.querySelector('.aquatix-voice-note__waveform');
    var bars     = Array.prototype.slice.call(waveform.querySelectorAll('.aquatix-voice-note__bar'));
    var raf;

    function paintBars(pct) {
      var threshold = Math.round(pct * bars.length);
      bars.forEach(function (bar, i) {
        bar.style.background = i < threshold ? '#00a884' : '#4a5a63';
      });
    }

    function tick() {
      if (audio.duration) paintBars(audio.currentTime / audio.duration);
      if (!audio.paused && !audio.ended) raf = requestAnimationFrame(tick);
    }

    audio.addEventListener('ended', function () {
      cancelAnimationFrame(raf);
      el.removeAttribute('data-playing');
      paintBars(0);
    });

    btn.addEventListener('click', function () {
      if (audio.paused) {
        document.querySelectorAll('.aquatix-voice-note[data-playing]').forEach(function (other) {
          if (other !== el) other.querySelector('.aquatix-voice-note__btn').click();
        });
        audio.play().then(function () { raf = requestAnimationFrame(tick); });
        el.setAttribute('data-playing', '');
      } else {
        audio.pause();
        el.removeAttribute('data-playing');
        cancelAnimationFrame(raf);
      }
    });

    waveform.addEventListener('click', function (e) {
      if (!audio.duration) return;
      var pct = Math.max(0, Math.min(1, (e.clientX - waveform.getBoundingClientRect().left) / waveform.offsetWidth));
      audio.currentTime = pct * audio.duration;
      paintBars(pct);
    });
  }

  function initAll(root) {
    initAllCarousels(root);
    guardVideos(root);
    (root || document).querySelectorAll('[data-aqx-video-facade]:not([data-aqx-init])').forEach(initVideoFacade);
    (root || document).querySelectorAll('.aquatix-voice-note:not([data-init])').forEach(initVoiceNote);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
